(function () {
  'use strict';

  /*
   * Kodun birden fazla kez yüklenmesi durumunda
   * fetch ve XMLHttpRequest tekrar değiştirilmesin.
   */
  if (window.__hausonePredictiveSkuSearchLoaded) {
    return;
  }

  window.__hausonePredictiveSkuSearchLoaded = true;

  var searchableFields = [
    'title',
    'product_type',
    'vendor',
    'variants.title',
    'variants.sku'
  ].join(',');

  /**
   * Shopify predictive search isteğine
   * variants.sku arama alanını ekler.
   *
   * @param {string|URL} inputUrl
   * @returns {string}
   */
  function addSkuSearchField(inputUrl) {
    try {
      var originalUrl = inputUrl.toString();
      var url = new URL(originalUrl, window.location.origin);

      var pathname = url.pathname.replace(/\/+$/, '');

      var isPredictiveSearch =
        pathname.endsWith('/search/suggest') ||
        pathname.endsWith('/search/suggest.json');

      if (!isPredictiveSearch) {
        return originalUrl;
      }

      url.searchParams.set(
        'resources[options][fields]',
        searchableFields
      );

      return url.toString();
    } catch (error) {
      console.warn(
        'Predictive search URL could not be modified:',
        error
      );

      return inputUrl.toString();
    }
  }

  /*
   * Xtra teması fetch kullanıyorsa.
   */
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, options) {
      try {
        if (input instanceof Request) {
          var modifiedRequestUrl = addSkuSearchField(input.url);

          if (modifiedRequestUrl !== input.url) {
            input = new Request(modifiedRequestUrl, input);
          }
        } else if (
          typeof input === 'string' ||
          input instanceof URL
        ) {
          input = addSkuSearchField(input);
        }
      } catch (error) {
        console.warn(
          'Predictive SKU fetch modification failed:',
          error
        );
      }

      return originalFetch(input, options);
    };
  }

  /*
   * Xtra teması XMLHttpRequest kullanıyorsa.
   */
  if (typeof window.XMLHttpRequest === 'function') {
    var originalXhrOpen = window.XMLHttpRequest.prototype.open;

    window.XMLHttpRequest.prototype.open = function (
      method,
      url,
      async,
      username,
      password
    ) {
      var modifiedUrl = url;

      try {
        modifiedUrl = addSkuSearchField(url);
      } catch (error) {
        console.warn(
          'Predictive SKU XHR modification failed:',
          error
        );
      }

      return originalXhrOpen.call(
        this,
        method,
        modifiedUrl,
        async !== false,
        username,
        password
      );
    };
  }
})();